/* eslint-disable max-len */
import { cn } from '../cn';

export const IconWarning = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1324_7830)'>
      <path d='M12 9V13' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M10.363 3.59101L2.257 17.125C2.0899 17.4144 2.00147 17.7425 2.00051 18.0766C1.99955 18.4108 2.0861 18.7394 2.25155 19.0297C2.41699 19.3201 2.65557 19.562 2.94354 19.7316C3.23152 19.9011 3.55886 19.9923 3.893 19.996H20.107C20.441 19.9922 20.7682 19.901 21.056 19.7315C21.3438 19.562 21.5823 19.3202 21.7477 19.03C21.9132 18.7398 21.9997 18.4114 21.9989 18.0774C21.9981 17.7434 21.9099 17.4154 21.743 17.126L13.637 3.59001C13.4665 3.30851 13.2262 3.07575 12.9395 2.9142C12.6527 2.75266 12.3291 2.66779 12 2.66779C11.6709 2.66779 11.3473 2.75266 11.0606 2.9142C10.7738 3.07575 10.5335 3.30851 10.363 3.59001V3.59101Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M12 16H12.01' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
    </g>
    <defs>
      <clipPath id='clip0_1324_7830'>
        <rect width='24' height='24' fill='currentColor'/>
      </clipPath>
    </defs>
  </svg>
);
